function ReportAbuse() {
  return (
    <>
      <div className="listpgWraper">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <div className="userccount">
                {" "}
                <form
                  method="POST"
                  action="https://hsalghanimdelivery.com/report-abuse/ios-developer-2"
                  acceptCharset="UTF-8"
                >
                  <input
                    name="_token"
                    type="hidden"
                    defaultValue="JRpFHzVW3juM0v9aaixP0bnd7i12iC2hXMI6K0Vw"
                  />
                  <div className="formpanel">
                    {/* Ad Information */}
                    <h5>Report Abuse</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="formrow">
                          <input
                            className="form-control"
                            id="job_url"
                            placeholder="URL"
                            required="required"
                            readOnly="readonly"
                            name="job_url"
                            type="text"
                            defaultValue="https://hsalghanimdelivery.com/job/ios-developer-2"
                            fdprocessedid="05tncn"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="formrow">
                          <input
                            className="form-control"
                            id="your_name"
                            placeholder="Your Name"
                            required="required"
                            name="your_name"
                            type="text"
                            defaultValue
                            fdprocessedid="j1wu1s"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="formrow">
                          <input
                            className="form-control"
                            id="your_email"
                            placeholder="Your Email"
                            required="required"
                            name="your_email"
                            type="text"
                            defaultValue
                            fdprocessedid="cw8d8e"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="formrow">
                          <div
                            data-sitekey="6LdLUZMUAAAAAF1F0GWT6nq7nh_mCqyet58GySE3"
                            className="g-recaptcha"
                          >
                            <div style={{ width: 304, height: 78 }}>
                              <div>
                                <iframe
                                  title="reCAPTCHA"
                                  src="https://www.google.com/recaptcha/api2/anchor?ar=1&k=6LdLUZMUAAAAAF1F0GWT6nq7nh_mCqyet58GySE3&co=aHR0cHM6Ly9oc2FsZ2hhbmltZGVsaXZlcnkuY29tOjQ0Mw..&hl=en&v=vpEprwpCoBMgy-fvZET0Mz6L&size=normal&cb=ipect4ctqvxf"
                                  width={304}
                                  height={78}
                                  role="presentation"
                                  frameBorder={0}
                                  scrolling="no"
                                  sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"
                                />
                              </div>
                              <textarea
                                id="g-recaptcha-response-2"
                                name="g-recaptcha-response"
                                className="g-recaptcha-response"
                                style={{
                                  width: 250,
                                  height: 40,
                                  border: "1px solid rgb(193, 193, 193)",
                                  margin: "10px 25px",
                                  padding: 0,
                                  resize: "none",
                                  display: "none",
                                }}
                                defaultValue={""}
                              />
                            </div>
                            <iframe style={{ display: "none" }} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <input
                      type="submit"
                      id="post_ad_btn"
                      className="btn"
                      defaultValue="Report"
                      fdprocessedid="axwtro"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ReportAbuse;
